import React from 'react';

import Picture from './picture';
import { IHeroPicture } from './types';

const Hero: React.FC<IHeroPicture> = ({ image, alt }) => <Picture image={image} alt={alt} />;

export default Hero;
